import { ContainerComponent, wrap } from 'AppReact';
import { DownloadDocumentSvg, GreenTickSvg, RightArrowSvg } from 'components/icons';
import {
  RelativeWrapper, FlexCenterWrapper, CursorPointerWrapper,
  Mr2, BorderedCard, HoverPrimary50BackgroundWrapper, Mt3,
  AbsolutePositionWrapper, WhiteSpaceNoWrap, Mb3, Mx4,
  FlexCenterBetweenWrapper, TooltipWrapper
} from 'wrappers';
import { SecondaryTextXs, Icon, SecondaryTextSm, SecondaryTextXs300, Tooltip, Empty } from 'atoms';
import React from 'react';
import internalState from './internalState';
import { OutlinedButton } from 'molecules';
import Controller from './controller';
import getIsMobile from "components/atoms/utils/getIsMobile";

const containerRef = React.createRef();
const isMobile = getIsMobile();

export const definition = {
  name: 'InspectionExport',
  initialProps: ({ disabled, hideCost, hideImages }) => ({ disabled, hideCost, includeCost: !hideCost, hideImages }),
  props: internalState,
  controller: Controller,
  elements: [
    {
      wrapper: RelativeWrapper,
      name: 'RelativeWrapper',
      ref: containerRef,
      elements: [
        {
          wrapper: TooltipWrapper,
          name: 'TooltipWrapper',
          elements: [
            {
              wrapper: CursorPointerWrapper,
              name: 'SelectorWrapper',
              displayState: ({ disabled }) => ({ disabled }),
              elements: [
                {
                  wrapper: FlexCenterWrapper,
                  name: 'Selector',
                  isButton: true,
                  bindings: ({ isOpen, containerRef, disabled }) => ({ isOpen, containerRef, disabled }),
                  elements: [
                    {
                      component: wrap(SecondaryTextXs, Mr2),
                      name: 'Text',
                      renderIf: ({ }) => !isMobile,
                      displayValue: ({ }) => 'Export'
                    },
                    {
                      component: Empty,
                      name: 'Icon',
                      displayValue: ({ }) => DownloadDocumentSvg({})
                    },

                  ]
                },
              ]
            },
            {
              component: Tooltip,
              name: 'Popup',
              renderIf: ({ disabled }) => !!disabled,
              displayValue: () => "No data available to export",
              displayState: () => ({ direction: 'left', whiteSpace: 'nowrap' })
            }
          ]
        },
        {
          wrapper: AbsolutePositionWrapper,
          name: "DropdownWrapper",
          displayState: ({ }) => ({ right: '0px', zIndex: 100, top: '36px' }),
          renderIf: ({ isOpen }) => isOpen,
          elements: [
            {
              wrapper: BorderedCard,
              name: 'Wrapper',
              displayState: ({ }) => ({ background: '#FFFFFF', borderRadius: '8px', padding: '0px' }),
              elements: [
                {
                  wrapper: wrap(wrap(wrap(FlexCenterBetweenWrapper, HoverPrimary50BackgroundWrapper), CursorPointerWrapper), Mt3),
                  name: 'Pdf',
                  isButton: true,
                  bindings: ({ showPdf }) => ({ showPdf }),
                  elements: [
                    {
                      component: SecondaryTextSm,
                      name: 'Text',
                      displayValue: ({ }) => 'PDF'
                    },
                    {
                      component: Icon,
                      name: 'Arrow',
                      displayValue: ({ }) => RightArrowSvg({})
                    }
                  ]
                },
                {
                  wrapper: wrap(wrap(wrap(FlexCenterWrapper, HoverPrimary50BackgroundWrapper), CursorPointerWrapper), Mb3),
                  name: 'Images',
                  isButton: true,
                  bindings: ({ }) => ({}),
                  elements: [
                    {
                      component: wrap(SecondaryTextSm, WhiteSpaceNoWrap),
                      name: 'Text',
                      displayValue: ({ }) => 'All images'
                    }
                  ]
                }
              ]
            },
            {
              wrapper: AbsolutePositionWrapper,
              name: "PdfDropdownWrapper",
              displayState: ({ }) => ({ right: 'calc(100% + 4px)', zIndex: 100, top: '0px' }),
              renderIf: ({ showPdf }) => showPdf,
              elements: [
                {
                  wrapper: BorderedCard,
                  name: 'Wrapper',
                  displayState: ({ }) => ({ background: '#FFFFFF', borderRadius: '8px', padding: '0px' }),
                  elements: [
                    {
                      component: wrap(wrap(SecondaryTextXs300, Mt3), Mx4),
                      name: 'Title',
                      displayValue: ({ }) => 'INCLUDE:'
                    },
                    {
                      wrapper: wrap(wrap(wrap(FlexCenterBetweenWrapper, HoverPrimary50BackgroundWrapper), CursorPointerWrapper), Mt3),
                      name: 'Images',
                      renderIf: ({ hideImages }) => !hideImages,
                      isButton: true,
                      bindings: ({ includeImages }) => ({ includeImages }),
                      elements: [
                        {
                          component: wrap(SecondaryTextSm, Mr2),
                          name: 'Text',
                          displayValue: ({ }) => 'Images'
                        },
                        {
                          component: Icon,
                          name: 'Check',
                          renderIf: ({ includeImages }) => includeImages,
                          displayValue: ({ }) => GreenTickSvg({})
                        }
                      ]
                    },
                    {
                      wrapper: wrap(wrap(wrap(FlexCenterBetweenWrapper, HoverPrimary50BackgroundWrapper), CursorPointerWrapper), Mt3),
                      name: 'Comments',
                      isButton: true,
                      bindings: ({ includeComments }) => ({ includeComments }),
                      elements: [
                        {
                          component: wrap(SecondaryTextSm, Mr2),
                          name: 'Text',
                          displayValue: ({ }) => 'Comments'
                        },
                        {
                          component: Icon,
                          name: 'Check',
                          renderIf: ({ includeComments }) => includeComments,
                          displayValue: ({ }) => GreenTickSvg({})
                        }
                      ]
                    },
                    {
                      wrapper: wrap(wrap(wrap(FlexCenterBetweenWrapper, HoverPrimary50BackgroundWrapper), CursorPointerWrapper), Mt3),
                      name: 'Cost',
                      isButton: true,
                      renderIf: ({ hideCost }) => !hideCost,
                      bindings: ({ includeCost }) => ({ includeCost }),
                      elements: [
                        {
                          component: wrap(SecondaryTextSm, Mr2),
                          name: 'Text',
                          displayValue: ({ }) => 'Cost'
                        },
                        {
                          component: Icon,
                          name: 'Check',
                          renderIf: ({ includeCost }) => includeCost,
                          displayValue: ({ }) => GreenTickSvg({})
                        }
                      ]
                    },
                    {
                      component: wrap(wrap(wrap(wrap(OutlinedButton, FlexCenterWrapper), Mx4), Mb3), Mt3),
                      name: 'Button',
                      bindings: ({ includeComments, includeImages, includeCost }) => ({ includeComments, includeImages, includeCost, title: "Export" }),
                    },
                  ]
                }
              ]
            },
          ]
        },
      ]
    },
  ]
};

export default wrap(ContainerComponent(definition), FlexCenterWrapper);
